import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const ateldConfig: TSPConfig = {
  key: 'ateld',
  name: 'ATELD',
  imageName: 'ATELD',
  category: TSPCategory.CUSTOM,
  helpText:
    "Please input the company ID from your ATELD profile. It should start with 'Company:' (like 'Company:12345').",
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Enter Company ID',
          name: 'apikey',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default ateldConfig;
